import { Link } from "react-router-dom";
import { ArrowUpRight, Factory, Mountains, Buildings, GearSix, Plant, GraduationCap, Blueprint as BlueprintIcon } from "@phosphor-icons/react";

const industries = [
  {
    id: "metals",
    name: "Metals & Steel",
    icon: Factory,
    image: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb25zdHJ1Y3Rpb24lMjBidWlsZGluZyUyMGluZnJhc3RydWN0dXJlfGVufDB8fHx8MTc4MjcxMTQ5NXww&ixlib=rb-4.1.0&q=85",
    tagline: "Precision at temperature. Intelligence at scale.",
    description:
      "Optimize production, quality, and energy across integrated steel plants and heavy metals operations.",
    capabilities: [
      "Production optimization",
      "Quality prediction",
      "Energy management",
      "Blast furnace analytics",
      "Yield & throughput intelligence",
    ],
    tint: "bg-rose-50",
    accent: "bg-rose-500",
    text: "text-rose-700",
    dot: "bg-rose-500",
  },
  {
    id: "mining",
    name: "Mining",
    icon: Mountains,
    image: "https://images.pexels.com/photos/12201831/pexels-photo-12201831.jpeg",
    tagline: "Safer sites. Smarter fleets. Higher yields.",
    description:
      "AI-driven predictive maintenance, safety analytics, and digital mine platforms for open-pit and underground operations.",
    capabilities: [
      "Predictive maintenance",
      "Fleet optimization",
      "Safety analytics",
      "Digital mines",
      "Ore quality prediction",
    ],
    tint: "bg-amber-50",
    accent: "bg-amber-500",
    text: "text-amber-700",
    dot: "bg-amber-500",
  },
  {
    id: "construction",
    name: "Construction & Infrastructure",
    icon: BlueprintIcon,
    image: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb25zdHJ1Y3Rpb24lMjBidWlsZGluZyUyMGluZnJhc3RydWN0dXJlfGVufDB8fHx8MTc4MjcxMTQ5NXww&ixlib=rb-4.1.0&q=85",
    tagline: "Deliver mega-projects on time, on budget.",
    description:
      "End-to-end project controls, EPC analytics, and AI scheduling for complex construction programs.",
    capabilities: [
      "Project controls",
      "Contractor oversight",
      "EPC analytics",
      "AI scheduling",
      "Cost & risk management",
    ],
    tint: "bg-orange-50",
    accent: "bg-orange-500",
    text: "text-orange-700",
    dot: "bg-orange-500",
  },
  {
    id: "manufacturing",
    name: "Manufacturing",
    icon: GearSix,
    image: "https://images.unsplash.com/photo-1761195696590-3490ea770aa1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxzbWFydCUyMG1hbnVmYWN0dXJpbmclMjBmYWN0b3J5JTIwd29ya2Vyc3xlbnwwfHx8fDE3ODMxNzIxMzV8MA&ixlib=rb-4.1.0&q=85",
    tagline: "Industry 4.0 — operationalized.",
    description:
      "Smart factories with quality analytics, predictive supply chains, and unified shop-floor intelligence.",
    capabilities: [
      "Industry 4.0 enablement",
      "Smart factory analytics",
      "Quality intelligence",
      "Supply chain optimization",
      "OEE & throughput uplift",
    ],
    tint: "bg-blue-50",
    accent: "bg-blue-600",
    text: "text-blue-700",
    dot: "bg-blue-600",
  },
  {
    id: "realty",
    name: "Realty & Facilities Management",
    icon: Buildings,
    image: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb25zdHJ1Y3Rpb24lMjBidWlsZGluZyUyMGluZnJhc3RydWN0dXJlfGVufDB8fHx8MTc4MjcxMTQ5NXww&ixlib=rb-4.1.0&q=85",
    tagline: "Buildings that think. Facilities that respond.",
    description:
      "Smart building operations, tenant intelligence, and energy optimization across commercial portfolios.",
    capabilities: [
      "Smart buildings",
      "Tenant management",
      "Energy optimization",
      "Parking & access management",
      "Digital facilities operations",
    ],
    tint: "bg-teal-50",
    accent: "bg-teal-600",
    text: "text-teal-700",
    dot: "bg-teal-600",
  },
  {
    id: "education",
    name: "Education",
    icon: GraduationCap,
    image: "https://images.pexels.com/photos/12903168/pexels-photo-12903168.jpeg",
    tagline: "Learning intelligence for the digital campus.",
    description:
      "AI-driven learning platforms, admissions automation, and student analytics for modern institutions.",
    capabilities: [
      "Learning intelligence",
      "AI tutoring",
      "Digital campus solutions",
      "Student analytics",
      "Admissions automation",
    ],
    tint: "bg-violet-50",
    accent: "bg-violet-600",
    text: "text-violet-700",
    dot: "bg-violet-600",
  },
  {
    id: "agriculture",
    name: "Agriculture",
    icon: Plant,
    image: "https://images.pexels.com/photos/34182412/pexels-photo-34182412.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tagline: "Precision farming, powered by AI.",
    description:
      "Crop intelligence, weather analytics, and sustainable agri-solutions for large-scale farms and cooperatives.",
    capabilities: [
      "Precision farming",
      "Crop intelligence",
      "Weather analytics",
      "Sustainable agriculture",
      "Yield forecasting",
    ],
    tint: "bg-emerald-50",
    accent: "bg-emerald-600",
    text: "text-emerald-700",
    dot: "bg-emerald-600",
  },
];

export default function Solutions() {
  return (
    <div data-testid="page-solutions">
      {/* HERO */}
      <section className="border-b border-zinc-200" data-testid="solutions-hero">
        <div className="container-x mx-auto py-20 lg:py-28">
          <div className="text-overline mb-6">Solutions & Industries</div>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95] max-w-5xl">
            Intelligence at the edge of every industry.
          </h1>
          <p className="mt-8 text-xl leading-relaxed text-zinc-600 max-w-3xl">
            Dedicated industry playbooks and platforms for heavy physical industries and smart
            infrastructure services. Choose your industry to explore capabilities.
          </p>

          {/* Anchor nav */}
          <div className="mt-10 flex flex-wrap gap-2">
            {industries.map((i) => (
              <a
                key={i.id}
                href={`#${i.id}`}
                data-testid={`solutions-jump-${i.id}`}
                className={`text-xs font-mono uppercase tracking-widest border-2 ${i.tint} border-transparent hover:border-current ${i.text} px-3 py-2 font-semibold transition`}
              >
                {i.name}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* INDUSTRIES */}
      {industries.map((ind, i) => (
        <section
          key={ind.id}
          id={ind.id}
          data-testid={`industry-section-${ind.id}`}
          className={`border-b border-zinc-200 scroll-mt-24 ${ind.tint}`}
        >
          <div className="container-x mx-auto py-20 lg:py-28">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="flex items-center gap-3 mb-6">
                  <div className={`inline-flex items-center justify-center w-12 h-12 ${ind.accent} text-white`}>
                    <ind.icon size={22} weight="light" />
                  </div>
                  <span className={`text-overline ${ind.text}`}>Industry 0{i + 1}</span>
                </div>
                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95]">
                  {ind.name}
                </h2>
                <p className={`mt-4 text-xl font-semibold ${ind.text}`} style={{ fontFamily: "Chivo" }}>
                  {ind.tagline}
                </p>
                <p className="mt-6 text-lg text-zinc-700 leading-relaxed">{ind.description}</p>

                <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                  {ind.capabilities.map((c) => (
                    <li key={c} className="flex items-start gap-3 text-sm text-zinc-900 bg-white px-3 py-2 border border-zinc-200">
                      <span className={`mt-1.5 w-2 h-2 ${ind.dot} shrink-0 rounded-full`} />
                      <span className="font-medium">{c}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/contact"
                  data-testid={`industry-cta-${ind.id}`}
                  className={`inline-flex items-center gap-2 mt-10 ${ind.accent} text-white px-5 py-3 text-sm font-semibold hover:opacity-90 transition-opacity shadow-md`}
                >
                  Talk to an expert <ArrowUpRight size={14} weight="bold" />
                </Link>
              </div>

              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <div className="relative border-4 border-white bg-white shadow-xl">
                  <img
                    src={ind.image}
                    alt={ind.name}
                    className="w-full h-[320px] lg:h-[440px] object-cover"
                    loading="lazy"
                  />
                  <div className={`absolute bottom-4 left-4 ${ind.accent} text-white px-3 py-2 shadow-lg`}>
                    <div className="text-[10px] font-mono tracking-widest opacity-80">Industry Module</div>
                    <div className="text-sm font-bold">{ind.name}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section className="border-b border-zinc-200" data-testid="solutions-cta">
        <div className="container-x mx-auto py-20 lg:py-28">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <h2 className="lg:col-span-8 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter">
              Don&apos;t see your industry? We build industrial intelligence for complex operations.
            </h2>
            <div className="lg:col-span-4 flex flex-col gap-3">
              <Link
                to="/contact"
                data-testid="solutions-cta-btn"
                className="inline-flex items-center justify-between bg-zinc-950 text-white px-6 py-4 text-sm font-semibold hover:bg-[#0A33D8] transition-colors"
              >
                Book a Consultation <ArrowUpRight size={16} weight="bold" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
